import r, { forwardRef as b } from "react";
import { splitCssProps as N } from "@huspy/styled-system/jsx";
import { sidebarMenu as e } from "@huspy/styled-system/recipes";
import { cx as f, css as E } from "@huspy/styled-system/css";
import { Lock as h } from "lucide-react";
import "@ark-ui/react";
import { Box as M } from "../../components/box/index.mjs";
import "../../components/button/button.mjs";
import "../../components/checkbox/checkbox.mjs";
import "../../components/icon-button/icon-button.mjs";
import "../../components/input/input.mjs";
import "../../components/input/input-group.mjs";
import "../../components/phone-input/phone-input.mjs";
import "../../components/pin-input/pin-input.mjs";
import "../../components/popover/popover.mjs";
import "../../components/chip/chip.mjs";
import "../../components/property-tag/property-tag.mjs";
import "../../components/slider/slider.mjs";
import "../../components/alert/alert.mjs";
import { Text as I } from "../../components/typography/text.mjs";
import "../../components/typography/title.mjs";
import "../../components/menu/menu.mjs";
import "../../components/progress/progress.mjs";
import "../../components/date-picker/date-picker.mjs";
import "../../components/tabs/tabs.mjs";
import "../../components/collapsible/collapsible.mjs";
import "../../components/dialog/dialog.mjs";
import "../../components/radio/radio.mjs";
import "../../components/radio-button/radio-button.mjs";
import "../../components/file-upload/file-upload.mjs";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "../../components/table/table.mjs";
import "../../components/pagination/pagination.mjs";
import "../../components/combobox/combobox.mjs";
import "../../components/select/select.mjs";
import "../../components/badge/badge.mjs";
import "../../components/property-chip/property-chip.mjs";
import "../../components/number-input/number-input.mjs";
import "../../components/switch/switch.mjs";
import "../../components/toast/base.mjs";
import "../../components/spinner/spinner.mjs";
import "../../components/property-badge/property-badge.mjs";
import "../../components/drawer/drawer.mjs";
import "../../components/skeleton/skeleton.mjs";
import { Slot as u } from "../../utils/Slot.mjs";
const C = b(({ asChild: m, ...t }, i) => {
  const p = m ? u : M, [s, c] = e.splitVariantProps(t), [n, a] = N(c), { children: l, className: P, ...o } = a, d = e(s);
  return /* @__PURE__ */ r.createElement(p, { ref: i, className: f(d.root, E(n), P), ...o }, l);
}), v = b(({ asChild: m, ...t }, i) => {
  const p = m ? u : M, [s, c] = e.splitVariantProps(t), [n, a] = N(c), { children: l, className: P, ...o } = a, d = e(s);
  return /* @__PURE__ */ r.createElement(p, { ref: i, className: f(d.submenu, E(n), P), ...o }, l);
}), x = b(({ asChild: m, ...t }, i) => {
  const p = m ? u : I, [s, c] = e.splitVariantProps(t), [n, a] = N(c), { children: l, className: P, ...o } = a, d = e(s);
  return /* @__PURE__ */ r.createElement(p, { ref: i, className: f(d.submenuTitle, E(n), P), ...o }, l);
}), y = b(({ asChild: m, ...t }, i) => {
  const p = m ? u : M, [s, c] = e.splitVariantProps(t), [n, a] = N(c), { className: l, ...P } = a, o = e(s);
  return /* @__PURE__ */ r.createElement(p, { ref: i, className: f(o.item, E(n), l), ...P }, /* @__PURE__ */ r.createElement(u, { className: o.itemIcon }, t.leftIcon), /* @__PURE__ */ r.createElement(I, { className: o.itemLabel }, t.children), s.disabled ? /* @__PURE__ */ r.createElement(u, { className: o.itemIcon }, /* @__PURE__ */ r.createElement(h, null)) : /* @__PURE__ */ r.createElement(u, { className: o.itemIcon }, t.rightIcon));
}), Mo = {
  Base: C,
  SubMenu: v,
  SubMenuTitle: x,
  Item: y
};
export {
  Mo as SidebarMenu
};
